module.exports = __webpack_public_path__ + "media/images/member/6-5db2a0b2f839b9a06cc4f1f7eb20a868.jpg";